import strFunc from '@/lib/lyg/string';
import TodoStateFunc from "@/pcomponents/common/content/todo/state/func/state_func";
import HomeWorkFileArea from "../../home_work_file";
import AddTodoArea from "./add_todo_area";
import TodoDataFunc from "@/pcomponents/common/content/todo/data/func/data_func";

function TodoArrTable(props: any) {
  let myProps = {
    user: {},
    stu_info: {},
    select_date: "",
    subject_name: "",
    callback: (inData: any) => { },
    style: {},
    sort_data: {},
    todo_arr: [],
    on_change_todo: (inData: any) => { },
    on_delete_todo: (inData: any) => { },
    add_todo_arr: [],
    set_add_todo_arr: (inData: any) => { },
    add_new_todo_row_by_ajax: (inData: any) => { },
    check_todo_pri_val_arr: [],
    set_check_todo_pri_val_arr: (inData: any) => { },
    openTodoWriteOnePopup: (inData: any) => { },
    open_todo_word_result_one_popup: (inData: any) => { },
    /*
    "value":e.target.value,
    "name":amount_key,
    "todo_pri_val":todo_info["a_ymd"]+","+todo_info["a_seq"],
    */
    ...props
  };
  let Style = myProps.style;
  let user = myProps.user;
  const add_todo_row = () => {
    let add_row_data: any = {
      a_sort: myProps.sort_data.sort,
      a_stu_mcomp_user_seq: "",
      a_stu_name: "",
      a_subject: myProps.subject_name,
    };
    if (myProps.stu_info) {
      add_row_data.a_stu_mcomp_user_seq = myProps.stu_info.a_seq;
      add_row_data.a_stu_name = myProps.stu_info.a_user_name;
    }
    let new_todo_info: any = TodoDataFunc.get_default_todo_info({
      select_date: myProps.select_date,
      mcomp_seq: user.comp_seq,
      mcomp_user_seq: user.user_seq,
      mcomp_user_name: user.user_name,
      main_user_seq: user.main_user_seq,
      row_data: add_row_data,
    });
    let change_add_todo_arr = [...myProps.add_todo_arr];
    change_add_todo_arr.push(new_todo_info);
    myProps.set_add_todo_arr(change_add_todo_arr);
  };

  const get_color_style_of_sum_tag = (percent: number) => {
    let con_wrap_style: any = {};
    let con_bar_style: any = {};
    let per_span_style: any = {};
    if (percent == 0) {
      con_wrap_style["background"] = "#FAD5CC";
      con_bar_style["background"] = "#F48282";
      per_span_style["color"] = "#E18685";
    } else if (percent > 0) {
      con_wrap_style["background"] = "#FAF1E0";
      con_bar_style["background"] = "#EBBD70";
      per_span_style["color"] = "#E0BA7B";
    }
    if (percent >= 100) {
      con_wrap_style["background"] = "#EFF3D0";
      con_bar_style["background"] = "#B7C528";
      per_span_style["color"] = "#B0BA3F";
    }
    return {
      wrap: con_wrap_style,
      bar: con_bar_style,
      per: per_span_style
    };
  };
  let sum_color_style = get_color_style_of_sum_tag(myProps.sort_data.percent);

  const change_up_down_ing_value = (inData: any) => {
    let opt_obj = {
      up_down: "up",//up down
      name: "",
      value: "",
      todo_pri_val: "",
      ...inData
    };
    let value = parseInt(strFunc.uncomma(opt_obj.value));

    if (opt_obj.up_down == "up") {
      value++;
    } else {
      value--;
    }
    if (value < 0) {
      value = 0;
    }

    myProps.on_change_todo({
      "value": value,
      "name": opt_obj.name,
      "todo_pri_val": opt_obj.todo_pri_val,
    });
  };

  const on_check_todo_row = (inData: any) => {
    let opt_obj = {
      todo: {},
      is_checked: false,
      ...inData
    };
    let row_pri_val = opt_obj.todo.row_pri_val;
    let is_checked = opt_obj.is_checked;
    if (is_checked) {
      //추가
      let change_check_arr = [...myProps.check_todo_pri_val_arr];
      if (strFunc.str_in_array(row_pri_val, change_check_arr) == -1) {
        change_check_arr.push(row_pri_val);
      }
      myProps.set_check_todo_pri_val_arr(change_check_arr);
    } else {
      let change_check_arr = [];
      for (let i = 0; i < myProps.check_todo_pri_val_arr.length; i++) {
        if (myProps.check_todo_pri_val_arr[i] != row_pri_val) {
          change_check_arr.push(myProps.check_todo_pri_val_arr[i]);
        }
      }
      myProps.set_check_todo_pri_val_arr(change_check_arr);
    }
  };

  const on_check_todo_group = (inData: any) => {
    let opt_obj = {
      is_checked: false,
      ...inData
    };
    let is_checked = opt_obj.is_checked;
    if (is_checked) {
      let change_check_arr = [];
      for (let i = 0; i < myProps.todo_arr.length; i++) {
        let todo_info = myProps.todo_arr[i];
        let row_pri_val = todo_info.row_pri_val;
        change_check_arr.push(row_pri_val);
      }
      myProps.set_check_todo_pri_val_arr(change_check_arr);
    } else {
      myProps.set_check_todo_pri_val_arr([]);
    }
  };

  const get_todo_tags = () => {
    let todo_tags = myProps.todo_arr.map((todo_info: any, idx: number) => {
      let is_checked_row = false;
      if (strFunc.str_in_array(todo_info.row_pri_val, myProps.check_todo_pri_val_arr) != -1) {
        is_checked_row = true;
      }
      let row_per: any = TodoStateFunc.get_percent_by_todo_info(todo_info);
      let max_amout = 0;
      let ing_amout = 0;
      let amount_sort = "개";
      let amount_key = "a_amount_num";
      let todo_time_his = strFunc.secondsToTimeJson(parseInt(strFunc.uncomma(todo_info.elapse_time_sec)));
      let row_file_cnt = 0;
      if (todo_info.a_success_sort == "time") {
        max_amout = parseInt(strFunc.uncomma(todo_info.a_success_time_sec));
        ing_amout = parseInt(strFunc.uncomma(todo_info.a_time_sec));
        amount_sort = "분";
        amount_key = "a_time_sec";
      } else if (todo_info.a_success_sort == "amount") {
        max_amout = parseInt(strFunc.uncomma(todo_info.a_success_amount));
        ing_amout = parseInt(strFunc.uncomma(todo_info.a_amount_num));
        amount_sort = todo_info.a_amount_sort;
      }
      if (max_amout != 0 && ing_amout != 0) {
        row_per = (ing_amout / max_amout) * 100;
        row_per = parseInt(row_per);
      }
      if (todo_info["a_is_success"] == "1") {
        row_per = 100;
      }
      if (todo_info.file_arr) {
        row_file_cnt = todo_info.file_arr.length;
      }

      return (
        <tr key={idx}>
          <td>
            <div className='my_flex_center'>
              <input type="checkbox"
                checked={is_checked_row}
                onChange={(e: any) => {
                  on_check_todo_row({
                    todo: todo_info,
                    is_checked: e.target.checked
                  });
                }}
                style={{ marginRight: 5 }} />
              <div className={Style.todo_arr_th_first} title={todo_info.a_title}
                onClick={() => {
                  // myProps.openTodoWriteOnePopup({
                  //   todo_info: todo_info
                  // });
                }}>
                <input type='text' readOnly value={todo_info.a_title} onChange={() => { }}
                  style={{ width: "80%", border: 0 }} />
                {row_file_cnt > 0 &&
                  <span style={{ color: "blue" }}>({row_file_cnt})</span>
                }
              </div>
            </div>
          </td>
          <td>
            {parseInt(todo_time_his.h + "") != 0 &&
              <span>{todo_time_his.h + ":"}</span>
            }
            {todo_time_his.i + ":" + todo_time_his.s}
          </td>
          <td>
            {max_amout}
            {" " + amount_sort}
          </td>
          <td>{row_per}%</td>
          <td>
            <div style={{ minWidth: 180 }}>
              <input type="text" className={Style.todo_arr_td_input}
                value={ing_amout}
                name="ing_amout"
                onChange={(e: any) => {
                  myProps.on_change_todo({
                    "value": e.target.value,
                    "name": amount_key,
                    "todo_pri_val": todo_info["a_ymd"] + "," + todo_info["a_seq"],
                  });
                }}
                onClick={(e: any) => {
                  e.target.select();
                }}
                style={{ width: 40 }} />
              {todo_info.a_amount_sort}
              <button className="btn-s2 btn-gray ml-1"
                onClick={() => {
                  change_up_down_ing_value({
                    value: ing_amout,
                    name: amount_key,
                    "todo_pri_val": todo_info["a_ymd"] + "," + todo_info["a_seq"],
                    up_down: "up"
                  });
                }}>▲</button>
              <button className="btn-s2 btn-gray ml-1"
                onClick={() => {
                  change_up_down_ing_value({
                    value: ing_amout,
                    name: amount_key,
                    "todo_pri_val": todo_info["a_ymd"] + "," + todo_info["a_seq"],
                    up_down: "down"
                  });
                }}>▼</button>
              {(todo_info.a_sort_det == "cg_word"||todo_info.a_sort_det == "cg_word_custom") &&
                <button className='btn-s2 btn-dark ml-1'
                  onClick={() => {
                    myProps.open_todo_word_result_one_popup({
                      todo_info: todo_info
                    });
                  }}>결과보기</button>
              }
              <button className="btn-s2 btn-dark ml-1"
                onClick={() => {
                  myProps.on_delete_todo({
                    todo_info_arr: [todo_info]
                  });
                }}
              >X</button>
            </div>
          </td>
        </tr>
      );
    });

    return todo_tags;
  };

  let sort_file_arr: any = [];
  if (myProps.sort_data.sort == "homework") {
    sort_file_arr = myProps.stu_info.home_work_file_arr ? myProps.stu_info.home_work_file_arr : [];
  } else if (myProps.sort_data.sort == "study") {
    sort_file_arr = myProps.stu_info.plan_study_file_arr ? myProps.stu_info.plan_study_file_arr : [];
  }
  if (myProps.sort_data.file_arr) {
    sort_file_arr = [
      ...sort_file_arr,
      ...myProps.sort_data.file_arr
    ];
  }

  let homework_file_s_par_id = "home_work_file";
  if (myProps.sort_data.sort == "study") {
    homework_file_s_par_id = "plan_study_file";
  }

  return (
    <div className={Style.todo_arr_table}>
      <table>
        <colgroup>
          <col width={"32%"}></col>
          <col width={"10%"}></col>
          <col width={"15%"}></col>
          <col width={"8%"}></col>
          <col width={"35%"}></col>
        </colgroup>
        <thead>
          <tr style={sum_color_style.wrap}>
            <th>
              <div className={Style.todo_arr_th_first}>
                <div className={Style.todo_arr_th_first_bar} style={sum_color_style.bar} ></div>
                <label>
                  <span className='mr-1'>
                    <input type='checkbox' onChange={(e: any) => { on_check_todo_group({ is_checked: e.target.checked }); }} />
                  </span>
                  {myProps.sort_data.title}
                </label>
                <button className="btn-s btn-sky ml-1" onClick={() => {
                  add_todo_row();
                }}>+</button>
              </div>
            </th>
            <th>분:초</th>
            <th>목표량</th>
            <th style={sum_color_style.per} >{myProps.sort_data.percent}%</th>
            <th>달성량</th>
          </tr>
        </thead>
        <tbody>
          {get_todo_tags()}
          <AddTodoArea
            Style={Style}
            add_todo_arr={myProps.add_todo_arr}
            set_add_todo_arr={myProps.set_add_todo_arr}
            add_new_todo_row_by_ajax={myProps.add_new_todo_row_by_ajax}
          ></AddTodoArea>
        </tbody>
      </table>

      <HomeWorkFileArea
        stu_info={myProps.stu_info}
        select_date={myProps.select_date}
        s_par_id={homework_file_s_par_id}
        s_par_seq={myProps.subject_name}
        sort2={myProps.subject_name}
        file_arr={sort_file_arr}
        callback={myProps.callback}
        is_show_audio={false}
        is_show_video={false}
        is_show_upload={false}
      ></HomeWorkFileArea>
    </div>
  );
};
export default TodoArrTable;